const e = (t) => t !== null && typeof t == "object";
export {
  e as isObject
};
